module.exports = ".content.wrapper {\n  padding-top: 15px;\n  background: oldlace; }\n\n.sticky-top {\n  top: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main